/**
 * Ingatan peramban tentang pintasan grup WhatsApp SIPAUD.
 *
 * Dipisah dari komponennya karena dipakai berdua: panel melayang yang menulis
 * keputusannya, dan kartu di Dashboard yang perlu tahu apakah panel itu sedang
 * ditutup — supaya bisa menawarkan memunculkannya kembali. Dua salinan kunci
 * penyimpanan yang boleh berbeda isi adalah cara termudah membuat tombol
 * "munculkan lagi" menghapus penanda yang salah, lalu tampak tidak berfungsi.
 *
 * Semuanya disimpan di peramban orang itu sendiri, bukan di server: ini
 * ajakan, bukan pengaturan lembaga, dan keputusan satu guru untuk
 * menyingkirkannya tidak boleh ikut menyingkirkannya dari layar rekan-rekannya.
 */

/**
 * Ditutup permanen — localStorage, bertahan lintas sesi.
 *
 * Yang disimpan adalah TAUTAN yang ditutup, bukan sekadar bendera "sudah
 * ditutup": bila Super Admin kelak memasang grup yang BERBEDA, ajakannya
 * muncul lagi. Yang ditolak orang adalah undangan ke grup yang ia sudah tahu,
 * bukan janji seumur hidup untuk tidak pernah diberi tahu tentang grup mana
 * pun.
 */
export const COMMUNITY_CLOSED_KEY = 'sipaud.community-closed';

/**
 * Disembunyikan sementara — sessionStorage, habis saat tab ditutup.
 *
 * Wajib bertahan antar halaman: panel muncul di SETIAP halaman, dan
 * penyembunyian yang lupa begitu orang pindah menu bukan penyembunyian sama
 * sekali — ia hanya memindahkan pekerjaan menutupnya ke halaman berikutnya.
 */
export const COMMUNITY_MINIMIZED_KEY = 'sipaud.community-minimized';

export type ShortcutStorage = 'local' | 'session';

function store(kind: ShortcutStorage): Storage {
  return kind === 'local' ? window.localStorage : window.sessionStorage;
}

/**
 * Membaca penanda dari penyimpanan peramban.
 *
 * Mode penyamaran dan peramban yang memblokir penyimpanan situs MELEMPAR di
 * sini, bukan sekadar memulangkan null. Tidak apa-apa: yang hilang hanya
 * ingatan bahwa panel pernah ditutup, dan itu jauh lebih ringan daripada
 * seluruh halaman gagal dirender karena satu ajakan tidak bisa membaca
 * localStorage.
 */
export function readShortcutFlag(kind: ShortcutStorage, key: string): string | null {
  try {
    return store(kind).getItem(key);
  } catch {
    return null;
  }
}

export function writeShortcutFlag(kind: ShortcutStorage, key: string, value: string): void {
  try {
    store(kind).setItem(key, value);
  } catch {
    // Sengaja diabaikan — lihat catatan di readShortcutFlag().
  }
}

export function clearShortcutFlag(kind: ShortcutStorage, key: string): void {
  try {
    store(kind).removeItem(key);
  } catch {
    // Sengaja diabaikan — lihat catatan di readShortcutFlag().
  }
}

/** Alamat panjang dipendekkan agar muat satu baris tanpa memotong identitasnya. */
export function shortenUrl(url: string): string {
  const bare = url.replace(/^https?:\/\//, '');

  return bare.length > 38 ? `${bare.slice(0, 38)}…` : bare;
}
